/**
 * 用户信息的 cookie 读取（唯一定义处，叶子模块，只依赖 js-cookie，避免循环依赖）。
 *
 * 这一份是「主应用用到、且要下发给 micro-app 子应用」的全部用户身份字段。
 * global.userInfo 由它初始化，store 的 flushUserInfoFromCookie 也用它刷进 Vuex。
 * 主应用新增会用到的身份字段时，在这里补全即可，两处自动一致。
 */
import Cookies from 'js-cookie'

export function readUserInfoFromCookie() {
  return {
    // —— 基础身份 ——
    userName: Cookies.get('userName'),
    userCode: Cookies.get('userCode'),
    // —— 组织 / 配送 / 仓 ——
    orgNo: Cookies.get('orgNo'),
    distributeNo: Cookies.get('distributeNo'),
    warehouseNo: Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo'),
    warehouseName: Cookies.get('login.select.warehouse.name') || Cookies.get('warehouseName'),
    // —— 登录态 / 租户（鉴权、埋点、子应用都要用）——
    loginType: Cookies.get('lwms.lt') || 'b', // b(商家) / erp(内部)
    pin: Cookies.get('pin') || '',
    tenantId: Cookies.get('login.select.tenant') || '',
    // —— 菜单版本 / 语言 ——
    switch2WmsMenu: Cookies.get('lwms.s2wm') === 'true',
    language: Cookies.get('jd.erp.lang') || 'en-US'
  }
}
